var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeal = function SvgSeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1207,
    height: 983,
    viewBox: "0 0 1207 983",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 140,
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348 913h284.58",
    stroke: "#475091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 632h446.41",
    stroke: "#5DAFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 632h138.692",
    stroke: "#38AC71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 351h642.99",
    stroke: "#DB3937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 70h368.751",
    stroke: "#DA5787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 70h144.252",
    stroke: "#F8CA24"
  }))));
};
export default SvgSeal;